import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import SubtleBadge from 'components/common/SubtleBadge';

import paths from 'routes/paths';
import { TIME_OPTION } from 'constants/time';

export const getAdminShelfListColumns = (tenant, warehouse, onTransfer) => [
  {
    accessorKey: 'name',
    header: 'Shelf Name',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { name } = original;

      return <span>{name}</span>;
    },
  },
  {
    accessorKey: 'code',
    header: 'Shelf Code',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { id, code } = original;

      return (
        <Link to={paths.shelfDetails(tenant, warehouse, id)}>
          <strong>{code}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'warehouse',
    header: 'Warehouse',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { warehouse } = original;

      return <span>{warehouse.name}</span>;
    },
  },
  {
    accessorKey: 'priority',
    header: 'Priority',
    enableSorting: true,
    meta: {
      valueType: 'number',
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { priority } = original;

      return <span>{priority ?? 0}</span>;
    },
  },
  {
    accessorKey: 'is_active',
    header: 'Status',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      const { is_active } = original;

      return (
        <SubtleBadge pill bg={is_active ? 'success' : 'secondary'}>
          {is_active ? 'Active' : 'InActive'}
        </SubtleBadge>
      );
    },
  },
  {
    accessorKey: 'created',
    header: 'Created',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { created } = original;

      return (
        <span>{new Date(created).toLocaleString('en-IN', TIME_OPTION)}</span>
      );
    },
  },
  {
    id: 'actions',
    header: 'Actions',
    enableSorting: false,
    meta: {
      headerProps: { className: 'text-center' },
      cellProps: { className: 'text-center' },
    },
    cell: ({ row: { original } }) => {
      return (
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => onTransfer(original)}
        >
          Transfer Inventory
        </Button>
      );
    },
  },
];
